import React from "react";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import { SearchProvider } from "./context/SearchContext";
import FlightBookingForm from "./Components/FlightBookingForm";
import SearchResultsPage from "./pages/SearchResultsPage";

function App() {
  return (
    <SearchProvider>
      <Router>
        <Routes>
          <Route path="/" element={<FlightBookingForm />} />
          <Route path="/search-results" element={<SearchResultsPage />} />
        </Routes>
      </Router>
    </SearchProvider>
  );
}

export default App;
